// src/xmlFormatterUtils.js
export const formatXml = (xml) => {
    try {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xml, "application/xml");

        const parseError = xmlDoc.getElementsByTagName("parsererror");
        if (parseError.length > 0) {
            return "Invalid XML";
        }

        // Recursive serializer — tracks indent depth, avoids XMLSerializer (which adds xmlns)
        const serializeNode = (node, indent) => {
            if (node.nodeType === 3) { // text node
                const text = node.nodeValue.trim();
                return text ? text : null;
            }
            if (node.nodeType !== 1) return null; // skip comments, PI nodes, etc.

            const tagName = node.tagName;

            // Build attribute string (only actual attributes, no xmlns injection)
            let attrs = '';
            for (let i = 0; i < node.attributes.length; i++) {
                const attr = node.attributes[i];
                attrs += ` ${attr.name}="${attr.value}"`;
            }

            const childResults = Array.from(node.childNodes)
                .map(c => serializeNode(c, indent + '  '))
                .filter(s => s !== null);

            if (childResults.length === 0) {
                return `${indent}<${tagName}${attrs}/>`;
            }

            // Single inline text child — keep on one line
            if (childResults.length === 1 && !childResults[0].startsWith('<')) {
                return `${indent}<${tagName}${attrs}>${childResults[0]}</${tagName}>`;
            }

            // Block children — each on its own indented line
            const inner = childResults.map(c =>
                c.startsWith('<') ? c : `${indent}  ${c}`
            ).join('\n');
            return `${indent}<${tagName}${attrs}>\n${inner}\n${indent}</${tagName}>`;
        };

        return serializeNode(xmlDoc.documentElement, '');
    } catch (error) {
        return "Invalid XML";
    }
};
  